import React, { useEffect, useState } from 'react';
import { BookOpenText, Loader2, Clock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const API = process.env.REACT_APP_BACKEND_URL;
const TONES = {
  slate: 'bg-slate-100 text-slate-800 border-slate-300', amber: 'bg-amber-100 text-amber-900 border-amber-300', pink: 'bg-pink-100 text-pink-900 border-pink-300',
  sky: 'bg-sky-100 text-sky-900 border-sky-300', cyan: 'bg-cyan-100 text-cyan-900 border-cyan-300', teal: 'bg-teal-100 text-teal-900 border-teal-300',
  emerald: 'bg-emerald-100 text-emerald-900 border-emerald-300', lime: 'bg-lime-100 text-lime-900 border-lime-300', indigo: 'bg-indigo-100 text-indigo-900 border-indigo-300',
  violet: 'bg-violet-100 text-violet-900 border-violet-300', rose: 'bg-rose-100 text-rose-900 border-rose-300',
};

export default function LiteracyProgramPage() {
  const [data, setData] = useState(null);
  const todayIdx = new Date().getDay() - 1;

  useEffect(() => {
    fetch(`${API}/api/literacy-program`, { headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } }).then((r) => r.json()).then(setData);
  }, []);

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-5" data-testid="literacy-program-page">
      <div className="rounded-2xl bg-gradient-to-br from-rose-600 via-orange-500 to-amber-400 text-white p-6 shadow-lg">
        <h1 className="text-2xl font-bold flex items-center gap-2"><BookOpenText className="h-6 w-6" />{data.title}</h1>
        <p className="text-sm text-white/90 mt-1 flex items-center gap-2"><Clock className="h-4 w-4" />Every day {data.block.start}–{data.block.end} · Years {data.years.join(', ')} · follows the Syllabus Unpacking sequence</p>
      </div>
      <div className="rounded-2xl border overflow-hidden shadow-sm bg-white">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase text-slate-500">
              <tr>
                <th className="px-3 py-2 text-left w-24">Time</th>
                <th className="px-3 py-2 text-left w-44">Strand</th>
                {data.days.map((d, i) => <th key={d} className={`px-3 py-2 text-left ${i === todayIdx ? 'bg-emerald-100 text-emerald-800' : ''}`}>{d}{i === todayIdx && <Badge className="ml-2 bg-emerald-600 text-[10px]">Today</Badge>}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.slots.map((s, i) => (
                <tr key={i} className="border-t align-top" data-testid={`literacy-slot-${i}`}>
                  <td className="px-3 py-2 text-xs font-semibold text-slate-600 whitespace-nowrap">{s.time}</td>
                  <td className="px-3 py-2"><span className={`inline-block rounded-full border px-2.5 py-0.5 text-xs font-semibold ${TONES[s.colour] || TONES.slate}`}>{s.strand}</span></td>
                  {s.all ? (
                    <td colSpan={5} className={`px-3 py-2 text-slate-700 ${TONES[s.colour]?.split(' ')[0]}/40`}>{s.all}</td>
                  ) : s.days.map((v, j) => (
                    <td key={j} className={`px-3 py-2 text-slate-800 ${j === todayIdx ? 'bg-emerald-50 font-medium' : ''}`}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs text-slate-500">This block appears as "Literacy Program" (periods 1–2) on every Year 1–3 class timetable. Mathematics and other subjects continue from 09:45.</p>
    </div>
  );
}
